import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Chevron, { DIRECTIONS, SIZES } from 'components/Chevron';
import QuaternaryHeading from 'components/Headings/QuaternaryHeading';
import RichText from 'components/RichText';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const Item = ({ question, answer }) => {
  const [isActive, setIsActive] = useState(false);
  const chevronDirection = isActive ? DIRECTIONS.UP : DIRECTIONS.DOWN;

  return (
    <li className="FaqItem">
      <button className="FaqItem__button" onClick={() => setIsActive(!isActive)}>
        <span className="FaqItem__chevron">
          <Chevron direction={chevronDirection} size={SIZES.LARGE} />
        </span>
        <QuaternaryHeading className="FaqItem__title">{question}</QuaternaryHeading>
      </button>

      <span className={classNames('FaqItem__body', { 'FaqItem__body-active': isActive })}>
        <RichText className="FaqItem__richtext" content={answer} />
      </span>
      <style jsx>
        {`
          .FaqItem {
            position: relative;
            border-top: 1px solid ${Theme.get('colors-black-60')};
            padding: ${Theme.get('spacing') * 1.5}px 0;
          }

          .FaqItem__chevron {
            position: absolute;
            top: 0;
            right: 0;
            padding-top: ${Theme.get('spacing') * 2}px;
          }

          .FaqItem__body {
            display: block;
            max-height: 0;
            overflow: hidden;
            transition: max-height ${Theme.get('transition-duration') * 2}ms
              ${Theme.get('transition-timing-ease-out-quint')};
            padding-top: ${Theme.get('spacing')}px;
          }

          .FaqItem__body-active {
            max-height: 1000px;
            transition: max-height ${Theme.get('transition-duration') * 2.5}ms
              ${Theme.get('transition-timing-ease-in-out')};
          }

          .FaqItem__button {
            background: none;
            border: none;
            padding: 0;
            cursor: pointer;
            text-align: left;
            width: 100%;
          }

          @media ${largeUp} {
            .FaqItem {
              padding: ${Theme.get('spacing') * 2.5}px 0;
              position: relative;
              top: ${Theme.get('spacing')}px;
            }

            .FaqItem__body {
              padding: ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 4}px 0;
            }

            .FaqItem__button {
              padding-left: ${Theme.get('spacing') * 4}px;
            }

            .FaqItem__chevron {
              padding-top: ${Theme.get('spacing') * 3}px;
              right: ${Theme.get('spacing') * 4}px;
            }
          }
        `}
      </style>

      <style jsx global>
        {`
          .FaqItem__chevron .Chevron {
            border-bottom-width: 2px;
            border-right-width: 2px;
          }

          .FaqItem__richtext .Paragraph,
          .FaqItem__richtext .typography--strong,
          .FaqItem__richtext .InlineLink {
            font-size: ${Theme.get('font-size-description-px')};
            font-weight: ${Theme.get('font-weight-normal')};
          }

          .FaqItem__richtext.RichText .Paragraph {
            margin-bottom: ${Theme.get('spacing')}px;
          }

          .FaqItem .FaqItem__title {
            width: 90%;
          }

          @media ${largeUp} {
            .FaqItem .FaqItem__title {
              letter-spacing: 1.5px;
            }
          }
        `}
      </style>
    </li>
  );
};

Item.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.shape({}).isRequired,
};

export default Item;
